/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./consulta.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./consulta.component";
var styles_ConsultaComponent = [i0.styles];
var RenderType_ConsultaComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ConsultaComponent, data: {} });
export { RenderType_ConsultaComponent as RenderType_ConsultaComponent };
export function View_ConsultaComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" consulta works!\n"]))], null, null); }
export function View_ConsultaComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-consulta", [], null, null, null, View_ConsultaComponent_0, RenderType_ConsultaComponent)), i1.ɵdid(1, 114688, null, 0, i2.ConsultaComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ConsultaComponentNgFactory = i1.ɵccf("app-consulta", i2.ConsultaComponent, View_ConsultaComponent_Host_0, {}, {}, []);
export { ConsultaComponentNgFactory as ConsultaComponentNgFactory };
